<header class="header" *ngIf="!isEventRoute">
  <nav class="navbar navbar-expand-lg">
    <img
      class="logo"
      src="/assets/images/header/logo.png"
      (click)="scrollTo('')"
    />
    <button
      class="navbar-toggler"
      style="box-shadow: none"
      type="button"
      (click)="this.showMobileMenu = !this.showMobileMenu"
    >
      <i class="fa fa-bars"></i>
    </button>
    <div
      [class.show]="showMobileMenu"
      id="navbarSupportedContent"
      class="collapse navbar-collapse justify-content-between"
    >
      <ul class="navbar-nav mr-auto header-menu">
        <!-- <li class="nav-item">
          <div
            class="d-flex"
            style="justify-content: space-between; align-items: center"
          >
            <a
              (click)="closeDropdown()"
              class="nav-link"
              href="https://hcci.org.sa/lomi_hasawi25/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ "LomiHasawiConference" | translate }}
            </a>
          </div>
        </li> -->

        <li class="nav-item">
          <div
            class="d-flex"
            style="justify-content: space-between; align-items: center"
          >
            <a
              (click)="scrollTo('')"
              [ngClass]="{ active: activeLink === '' }"
              href="#"
              class="nav-link"
              >{{ "home" | translate }}</a
            >
          </div>
        </li>

        <li class="nav-item">
          <div
            class="d-flex"
            style="justify-content: space-between; align-items: center"
          >
            <a
              (click)="scrollTo('events')"
              [ngClass]="{ active: activeLink === 'events' }"
              href="#"
              class="nav-link"
              >{{ "events" | translate }}
            </a>
          </div>
        </li>
        <li class="nav-item">
          <div
            class="d-flex"
            style="justify-content: space-between; align-items: center"
          >
            <a
              (click)="scrollTo('contact-us')"
              [ngClass]="{ active: activeLink === 'contact-us' }"
              href="#"
              class="nav-link"
              >{{ "contact-us" | translate }}
            </a>
          </div>
        </li>
      </ul>
      <div class="my-2 my-lg-0 d-flex">
        <div
          *ngIf="showMobileMenu"
          ngbDropdown
          #myDrop
          [attr.autoClose]="true"
          class="d-inline-block lang-container"
        >
          <button
            (click)="onSwitchLanguages()"
            type="button"
            class="btn lang-btn"
          >
            <img
              class="mr-1"
              style="width: 22px"
              [src]="'/assets/images/header/worldB.svg'"
            />
            {{ "language" | translate }}
          </button>
        </div>
        <ul class="navbar-nav header-social">
          <li class="nav-item">
            <!-- <a
              href="https://www.instagram.com/ahsachamber"
              target="_blank"
              class="p-1"
              ><img
                class="rounded-border"
                [src]="'/assets/images/header/instgram.svg'"
            /></a> -->
            <a href="{{ INSTAGRAM_URL }}" target="_blank">
              <img [src]="'/assets/images/header/instgram.svg'" />
            </a>
          </li>
          <li class="nav-item">
            <a href="{{ TWITTER_URL }}" target="_blank">
              <img [src]="'/assets/images/header/x.svg'" />
            </a>
          </li>

          <li class="nav-item">
            <a href="{{ LINKEDIN_URL }}" target="_blank">
              <img [src]="'/assets/images/header/linked-in.svg'" />
            </a>
          </li>
        </ul>
        <div
          *ngIf="!showMobileMenu"
          ngbDropdown
          #myDrop
          [attr.autoClose]="true"
          class="d-inline-block lang-container"
        >
          <button
            (click)="onSwitchLanguages()"
            type="button"
            class="btn lang-btn"
          >
            {{ "language" | translate }}
            <img
              class="mr-1"
              style="width: 22px; margin-bottom: 4px"
              [src]="'/assets/images/header/worldB.svg'"
            />
          </button>
        </div>
        <div *ngIf="!(user$ | async)" class="auth-btns">
          <button
            type="button"
            class="btn auth-btns__login"
            tabindex="0"
            (click)="closeDropdown(); openModal('login')"
          >
            {{ "login" | translate }}
          </button>

          <button
            type="button"
            class="btn auth-btns__register"
            tabindex="0"
            (click)="closeDropdown(); openModal('signup')"
          >
            {{ "sign-up" | translate }}
          </button>
        </div>
        <div class="header-account" *ngIf="user$ | async">
          <ng-container>
            <div ngbDropdown [attr.autoClose]="true" class="d-inline-block">
              <button
                type="button"
                class="btn header-profile"
                [ngClass]="{ 'auth-btns__login': showMobileMenu }"
                ngbDropdownToggle
              >
                {{ (user$ | async)?.firstName }} {{ (user$ | async)?.lastName }}
                <i class="fa fa-user"></i>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button
                  (click)="closeDropdown()"
                  ngbDropdownItem
                  routerLink="/tickets/my-tickets"
                  class="logout-btn"
                >
                  {{ "MyTickets" | translate }}
                </button>
                <button
                  ngbDropdownItem
                  (click)="closeDropdown(); logout()"
                  class="logout-btn"
                >
                  {{ "logout" | translate }}
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </nav>
</header>

<header class="header-other" *ngIf="isEventRoute">
  <div style="display: flex; align-items: center">
    <img
      class="logo"
      src="/assets/images/header/white-logo.png"
      (click)="scrollTo('')"
    />
    <span class="title-name">
      <a href="#" class="nav-link">{{ "home" | translate }}</a>
    </span>
  </div>

  <div class="header-other__data">
    <div class="event-name">
      <span *ngIf="translate.currentLang === 'en' && eventNameEn === null">
        {{ eventNameAr }}
      </span>

      <span *ngIf="translate.currentLang === 'en' && eventNameEn !== null">
        {{ eventNameEn }}
      </span>

      <span *ngIf="translate.currentLang === 'ar'">
        {{ eventNameAr }}
      </span>
    </div>
    <div *ngIf="!showMobileMenu" ngbDropdown #myDrop [attr.autoClose]="true">
      <button (click)="onSwitchLanguages()" type="button" class="btn lang-btn">
        {{ "language" | translate }}

        <img
          class="mx-1"
          style="width: 22px; margin-bottom: 4px"
          [src]="'/assets/images/header/lang-white.svg'"
        />
      </button>
    </div>
  </div>
</header>
